import inovaone_api from "./inovaone_api";
import type { ItensNaoInventariadosResponse } from "@/types/item-nao-inventariado";

/**
 * Consulta os itens impressos e ainda nao inventariados do usuario.
 *
 * Auth (Authorization + id_conta) ja vem dos defaults globais do inovaone_api
 * setados no login (UsuarioContext).
 */
export async function buscarItensNaoInventariados(params: {
  id_usuario: string;
  page?: number;
  pageSize?: number;
  search?: string;
}): Promise<ItensNaoInventariadosResponse> {
  const { id_usuario, page = 0, pageSize = 30, search } = params;

  const response = await inovaone_api.get<ItensNaoInventariadosResponse>(
    "/impressao/itens-nao-inventariados",
    {
      params: {
        id_usuario,
        page,
        pageSize,
        ...(search ? { search } : {}),
      },
    },
  );

  return response.data;
}
